import React from 'react';
import styled, { keyframes } from 'styled-components';
import Text from '@/common/view/Text';
import Icon from '@/common/view/icons';
import type { Typescales } from '@/common/view/typescales';
import type { Size } from './util';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;
const widthMap: Record<Size, string> = {
  medium: '24px',
  small: '20px',
  xsmall: '18px',
} as const;

const LoaderBox = styled.div<{
  $size: Size;
}>`
  position: absolute;
  top: 50%;
  right: 50%;
  transform: translate(50%, -50%);

  svg {
    width: ${({ $size }) => widthMap[$size]};
    height: ${({ $size }) => widthMap[$size]};
    animation: ${rotate} 1s linear infinite;
  }
`;

interface LoaderProps {
  size: Size;
  typo: Typescales;
}
const Loader: React.FC<LoaderProps> = ({ size, typo }) => {
  return (
    <LoaderBox $size={size}>
      <Text typo={typo} color="inherit">
        <Icon.Loader />
      </Text>
    </LoaderBox>
  );
};

export default Loader;
